{
  "deselectedItem": "{item} ej markerat.",
  "select": "Markera",
  "selectedAll": "Alla markerade objekt.",
  "selectedCount": "{count, plural, =0 {Inga markerade objekt} one {# markerat objekt} other {# markerade objekt}}.",
  "selectedItem": "{item} markerat."
}
